module.exports = __webpack_public_path__ + "static/media/teams.0f47d45b.svg";